export default "__VITE_ASSET__80c76837__"